import styled from 'styled-components'
import ripple from '../../../styles/animations/ripple'
import { down, up } from 'styled-breakpoints'


export const footerDocs = {
  Content: styled.div`
    gap: 5px;
    padding: 10px 15px;
    height: 80%;
    overflow-y: auto;
  `
}

export const Content = styled.div`
  display: flex;
  width: 100%;
`

export const GridStyles = {
  Content: styled.div`
    ${ripple}
    padding: 15px;
    display: flex;
    max-width: 110px;
    height: 130px;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
  `,
  Folder: styled.img`
    width: 81px;
    height: 68px;
  `,
  Name: styled.div`
    text-align: center;
    font-size: 12px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.title};
    overflow: hidden;
    white-space: break-spaces;
    word-break: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  `,
}

export const ListStyles = {
  Content: styled.div`
    gap: 5px;
    padding: 10px 15px;
    flex: 1;
    overflow-y: auto;
  `,
  NameFile: styled.div<{ minWidth?: boolean }>`
    display: flex;
    width: 20%;
    ${({ minWidth }) => minWidth && `min-width: 300px;`}
    align-items: center;
    gap: 10px;
    flex-direction: row;
    padding: 0 8px;
  `,
  Row: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
  `,
  Folder: styled.img`
    width: 23px;
    height: 19px;
  `,
  Name: styled.div`
    font-size: 12px;
    font-weight: 800;
    color: ${({ theme }) => theme.colors.title};
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    white-space: normal;
    -webkit-box-orient: vertical;
  `,
}

export const LeftContent = styled.div`
  background-color: ${({ theme }) => theme.colors.secondary};
  width: 20%;
  padding: 20px;
  height: 100%;
  ${down('md')} {
    display: none;
  }
`

export const ContentRight = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  ${down('md')} {
    width: 100%;
  }
`
export const ContentRightBody = styled.div<{ isList: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`

export const HeaderContent = {
  Content: styled.div`
    display: flex;
    padding: 15px;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.secondary};
    gap: 15px;
  `,
  HeaderContent: styled.div``,
  ButtonList: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    margin-left: auto;
    img {
      width: 31px;
      height: 31px;
    }
    color: ${({ theme }) => theme.colors.title};
  `,
  Columns: styled.div`
    display: flex;
    background-color: ${({ theme }) => theme.colors.secondary};
    overflow: auto;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    ${up('md')} {
      overflow: hidden;
    }
  `,
  ColumnName: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    flex-direction: row;
    img {
      width: 31px;
      height: 31px;
    }
    color: ${({ theme }) => theme.colors.title};
  `,
  BreadCumbs: styled.div`
    flex-direction: row;
    display: flex;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
    gap: 5px;
  `,
  BreadName: styled.div`
    color: ${({ theme }) => theme.colors.label};
  `,
}

export const HomeStyles = {
  Row: styled.div`
    ${ripple}
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    img {
      width: 23px;
      height: 19px;
    }
  `,
  ContentInner: styled.div`
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  BreadName: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    flex-direction: row;
    color: ${({ theme }) => theme.colors.title};
  `,
  Label: styled.div`
    font-size: 14px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.title};
  `,
}


